import { useRef, useEffect } from "react";
import { Button } from "@/components/ui/button-new";
import { MessageSquare } from "lucide-react";
import * as Sentry from "@sentry/react";

interface SentryFeedbackButtonProps {
    className?: string;
    formTitle?: string;
    children?: React.ReactNode;
}

export function SentryFeedbackButton({ 
    className = "text-on-surface-variant",
    formTitle = "Send Feedback",
    children
}: SentryFeedbackButtonProps) {
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const feedback = Sentry.getFeedback();
        if (feedback && buttonRef.current) {
            feedback.attachTo(buttonRef.current, {
                formTitle,
            });
        }
    }, [formTitle]);

    return (
        <Button
            ref={buttonRef}
            variant="ghost"
            size="icon"
            className={className}
        >
            {children || (
                <>
                    <MessageSquare className="h-5 w-5" />
                    <span className="sr-only">Send Feedback</span>
                </>
            )}
        </Button>
    );
}